/*
  The staging gate's password box.

  It does not check the password — it cannot, and must not. It reloads the same
  URL with ?view=<password>, and Shopify decides: a name matching a template
  renders the page, anything else falls back to the gate. So the only thing this
  file can get wrong is convenience, never access.

  It also retries a remembered password once, so the team unlocks one page and
  then browses normally. That memory is sessionStorage, not localStorage: the
  password is forgotten when the browser closes, rather than sitting on the
  device indefinitely. The cost is that a new tab asks again, since
  sessionStorage is per-tab.
*/
(function () {
  var KEY = 'reasn:stg';
  var TRIED = 'reasn:stg:tried';

  var form = document.querySelector('[data-ea-password-form]');
  if (!form) return;

  var input = form.querySelector('input');
  var error = form.querySelector('[data-ea-password-error]');

  function read(store, key) {
    try {
      return store.getItem(key);
    } catch (e) {
      return null; // private mode, or storage blocked
    }
  }

  function go(password) {
    var url = new URL(window.location.href);
    url.searchParams.set('view', password);
    window.location.replace(url.toString());
  }

  var saved = read(sessionStorage, KEY);
  var tried = read(sessionStorage, TRIED);

  // Reaching the gate with a password we have not just tried means it is worth
  // one attempt. The tried marker is what stops this looping.
  if (saved && tried !== saved) {
    try {
      sessionStorage.setItem(TRIED, saved);
    } catch (e) {}
    go(saved);
    return;
  }

  // Back here with the password we just tried: it is wrong. Drop it and say so.
  if (saved && tried === saved) {
    try {
      sessionStorage.removeItem(KEY);
      sessionStorage.removeItem(TRIED);
    } catch (e) {}
    if (error) error.hidden = false;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var value = (input.value || '').trim();
    if (!value) return;

    try {
      sessionStorage.setItem(KEY, value);
      sessionStorage.removeItem(TRIED);
    } catch (e) {}

    go(value);
  });
})();
